export const list = state => state.eventEmailTemplates.list;
export const listArray = state => {
  const templates = list(state);
  return Object.keys(templates).map(k => templates[k]);
};
